import { inject, Injectable } from "@angular/core";
import { PathwaysService } from "../../../api/services";
import { environment } from "../../../environments/environment";
import {
  CompletePathwayDto,
  InitializePathwayDto,
  ResponsePathwayDto,
} from "../../../api/models";
import { Observable } from "rxjs";
import { TABLE_PAGE_SIZE } from "../../../constants/pagination.constants";

const TENANT = environment.tenant;

@Injectable({
  providedIn: "root",
})
export class PathwaysApiService {
  /** The pathways service */
  private readonly _pathwaysService: PathwaysService = inject(PathwaysService);

  /**
   * Finds active pathway by patient ID.
   * @param patientId The patient ID.
   * @returns The active pathway for the patient.
   */
  public findActiveByPatientId$(
    patientId: string,
  ): Observable<CompletePathwayDto> {
    return this._pathwaysService.pathwaysControllerGetActiveCompletePathway({
      tenant: TENANT,
      patientId,
    });
  }

  /**
   * Retrieves a pathway.
   * @param createdAt The pathway ID to retrieve.
   * @returns The retrieved pathway.
   */
  public findOne$(createdAt: string): Observable<ResponsePathwayDto> {
    return this._pathwaysService.pathwaysControllerFindOne({
      tenant: TENANT,
      createdAt,
    });
  }

  /**
   * Creates a new pathway from template
   * @param body the pathway initialization data
   * @returns the created pathway
   */
  public initPathway$(
    body: InitializePathwayDto,
  ): Observable<CompletePathwayDto> {
    return this._pathwaysService.pathwaysControllerInitialize({ body });
  }
}
